export function makeId(...parts) {
  return parts.filter(Boolean).join('_');
}